module.exports = __webpack_public_path__ + "img/WellenKönigin.9821dfe7.jpg";